import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import formatDate from '../../utils/formatDate';
import getUserInitials from '../../utils/getUserInitials';
import { getFullImageUrl } from '../../utils/api/services/image';
import paths from '../../paths';

// таблица дат https://momentjs.com/docs/#/displaying/format/

export default class AuthorBlock extends Component {
  static defaultProps = {
    dateFormat: 'normal',
    className: '',
    createDate: null,
  };

  static propTypes = {
    createDate: PropTypes.string,
    dateFormat: PropTypes.oneOf(['short', 'normal', 'full']),
    className: PropTypes.string,
    toPost: PropTypes.string,
    user: PropTypes.object.isRequired,
  };

  render() {
    const {
      createDate, dateFormat, className, toPost, user,
    } = this.props;

    if (!user) {
      return <div />;
    }
    
    const firstName = user.firstName || '';
    const lastName = user.lastName || '';
    const picture = user.picture || '';

    const fullName = `${firstName} ${lastName}`;
    const initials = getUserInitials(fullName) || fullName;
    const userLink = `${paths.advocates.profile}/${user.id}`;

    let pictureContent =
      picture
        ? (<img src={getFullImageUrl(picture)} className="author-img" alt={initials} />)
        : (<div className="author-img author-img--no-image">{initials}</div>);

    return (
      <div className={classNames('author', className, { '--deleted-user': user.isDeleted })}>
        {user.isDeleted
          ? (<div className="author-pic">{pictureContent}</div>)
          : (<Link to={userLink} className="author-pic">{pictureContent}</Link>)
        }

        <div className="author-main">
          <div className="author-name">
            {user.isDeleted
              ? fullName 
              : <Link to={userLink}>{fullName}</Link>
            }
          </div>
          {createDate ? (
            toPost ? (
              <div className="author-desc">
                <Link to={toPost}>{formatDate(createDate, dateFormat)}</Link>
              </div>
            ) : (
                <div className="author-desc">{formatDate(createDate, dateFormat)}</div>
              )
          ) : (
              ''
            )}
        </div>
      </div>
    );
  }
}
